import React, { useState, useEffect } from 'react';

// API
import axios from 'axios';
import { apiUrl, fileApiUrl } from '../../../config/apiConfig';
import api from '../../../services/api';
import apiUploads from '../../../services/apiUploads';

// RICH TEXT (Observações)
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DOMPurify from 'dompurify';

// STYLE
import './style.css';

// CONTEXT API
import { useUser } from '../../../contexts/userContext';
import { useColumns } from '../../../contexts/columnsContext';
import { useCard } from '../../../contexts/cardContext'

function ModuloEsquadrias({ idCard }) {

  // CONTEXT API
  const { user, getAccessLevel } = useUser();
  const { columnsUser } = useColumns();
  const {
    setOpenCloseModuloEsquadriasModal,
    setCards,
    currentCardData,
    addHistoricoCardContext,
  } = useCard();

  // ESTADOS LOCAL
  const [nomeObra, setNomeObra] = useState('');
  const [contatoObra, setContatoObra] = useState('');

  const [previsaoMedicao, setPrevisaoMedicao] = useState(null);
  const [statusMedicao, setStatusMedicao] = useState('Parado');
  const [previsaoProducao, setPrevisaoProducao] = useState(null);
  const [statusProducao, setStatusProducao] = useState('Parado');
  const [previsaoEntregaVidro, setPrevisaoEntregaVidro] = useState(null);
  const [statusEntregaVidro, setStatusEntregaVidro] = useState('Parado');
  const [previsaoVistoriaPre, setPrevisaoVistoriaPre] = useState(null);
  const [statusVistoriaPre, setStatusVistoriaPre] = useState('Parado');
  const [previsaoEntregaObra, setPrevisaoEntregaObra] = useState(null);
  const [statusEntregaObra, setStatusEntregaObra] = useState('Parado');
  const [previsaoInstalacao, setPrevisaoInstalacao] = useState(null);
  const [statusInstalacao, setIstatusInstalacao] = useState('Parado');
  const [previsaoVistoriaPos, setPrevisaoVistoriaPos] = useState(null);
  const [statusVistoriaPos, setStatusVistoriaPos] = useState('Parado');
  const [previsaoAssistencia, setPrevisaoAssistencia] = useState(null);

  const [prazoEntrega, setPrazoEntrega] = useState(null);
  const [statusPrazoEntrega, setStatusPrazoEntrega] = useState('Parado');
  const [diasAposMedicao, setDiasAposMedicao] = useState('');

  const [statusAssistencia, setStatusAssistencia] = useState('Parado');

  // Status de Carregamento
  const [statusCarregamento, setStatusCarregamento] = useState('Sem informação');

  // Novos campos de data
  const [dataLiberacaoFinanceiro, setDataLiberacaoFinanceiro] = useState(null);
  const [dataAssinaturaContrato, setDataAssinaturaContrato] = useState(null);
  const [dataLiberacaoProducao, setDataLiberacaoProducao] = useState(null);

  const [horasProducao, setHorasProducao] = useState(0);
  const [quantidadeEsquadrias, setQuantidadeEsquadrias] = useState(0);
  const [quantidadeQuadros, setQuantidadeQuadros] = useState(0);
  const [metrosQuadrados, setMetrosQuadrados] = useState(0);
  const [volumeConcretoM3, setVolumeConcretoM3] = useState('');
  const [volumeCargaM3, setVolumeCargaM3] = useState('');
  const [pesoCargaKg, setPesoCargaKg] = useState('');
  const [valorEtapaProducao, setValorEtapaProducao] = useState(0);
  const [transportador, setTransportador] = useState('');
  const [outro, setOutro] = useState('');
  const [localEstoque, setLocalEstoque] = useState('');

  const [obsObra, setObsObra] = useState('');

  const [listCor, setListCor] = useState([]);

  const [cor, setCor] = useState('');

  const [tempCardData, setTempCardData] = useState(null);
  const [historicoPedidoVendaFaktory, setHistoricoPedidoVendaFaktory] = useState([]);
  const [historicoFaktoryLoading, setHistoricoFaktoryLoading] = useState(false);
  const [historicoFaktoryError, setHistoricoFaktoryError] = useState('');

  const looksLikeHtml = (value) => /<\/?[a-z][\s\S]*>/i.test(String(value || ''));

  const escapeHtml = (unsafe) =>
    String(unsafe)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  // Compatibilidade: se vier texto puro do banco, converte para HTML (preservando quebras de linha)
  const normalizeObsToHtml = (value) => {
    if (value === null || value === undefined) return '';
    const str = String(value);
    if (str.trim() === '') return '';
    if (looksLikeHtml(str)) return str;
    const escaped = escapeHtml(str);
    return `<p>${escaped.replace(/\r\n|\r|\n/g, '<br/>')}</p>`;
  };

  const sanitizeObsHtml = (html) =>
    DOMPurify.sanitize(String(html || ''), {
      USE_PROFILES: { html: true },
      // Mantém classes do Quill (ex.: ql-size-*, ql-color-*) para formatações.
      ADD_ATTR: ['class'],
    });

  const normalizeOptionalDecimal = (value) => {
    if (value === null || value === undefined || String(value).trim() === '') return null;
    const raw = String(value).trim().replace(/\s/g, '');
    const normalized = raw.includes(',')
      ? raw.replace(/\./g, '').replace(',', '.')
      : raw;
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const quillModules = {
    toolbar: [
      [{ font: [] }, { size: [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
      ['clean'],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const quillFormats = [
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'color',
    'background',
    'align',
    'list',
    'bullet',
    'link',
  ];

  // Adicionar useEffect para lidar com a tecla ESC
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        setOpenCloseModuloEsquadriasModal(false);
      }
    };

    window.addEventListener('keydown', handleEscKey);

    // Cleanup function para remover o event listener
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, []);

  const handleSaveEsquadrias = async (e) => {
    e.preventDefault();

    // Verificar se o usuário tem permissão para editar módulo de esquadrias
    if (!getAccessLevel('editarModuloEsquadrias')) {
      alert('Você não tem permissão para salvar alterações no Módulo de Esquadrias!');
      return;
    }

    const invalidDocumentField = [volumeConcretoM3, volumeCargaM3, pesoCargaKg]
      .some((value) => String(value ?? '').trim() !== '' && normalizeOptionalDecimal(value) === null);
    if (invalidDocumentField) {
      alert('Informe apenas valores numéricos válidos nos dados do Sistema Construtivo.');
      return;
    }

    const safeObsHtml = sanitizeObsHtml(obsObra);

    const esquadriaData = {
      card_id: idCard,
      nome_obra: nomeObra,
      contato_obra: contatoObra,
      previsao_medicao: previsaoMedicao ? previsaoMedicao : null,
      status_medicao: statusMedicao,
      previsao_producao: previsaoProducao ? previsaoProducao : null,
      status_producao: statusProducao,
      previsao_entrega_vidro: previsaoEntregaVidro ? previsaoEntregaVidro : null,
      status_entrega_vidro: statusEntregaVidro,
      previsao_vistoria_pre: previsaoVistoriaPre ? previsaoVistoriaPre : null,
      status_vistoria_pre: statusVistoriaPre,
      previsao_entrega_obra: previsaoEntregaObra ? previsaoEntregaObra : null,
      status_entrega_obra: statusEntregaObra,
      previsao_instalacao: previsaoInstalacao ? previsaoInstalacao : null,
      status_instalacao: statusInstalacao,
      previsao_vistoria_pos: previsaoVistoriaPos ? previsaoVistoriaPos : null,
      status_vistoria_pos: statusVistoriaPos,
      previsao_assistencia: previsaoAssistencia ? previsaoAssistencia : null,
      status_assistencia: statusAssistencia,
      horas_producao: horasProducao,
      quantidade_esquadrias: quantidadeEsquadrias,
      quantidade_quadros: quantidadeQuadros,
      metros_quadrados: metrosQuadrados,
      volume_concreto_m3: normalizeOptionalDecimal(volumeConcretoM3),
      volume_carga_m3: normalizeOptionalDecimal(volumeCargaM3),
      peso_carga_kg: normalizeOptionalDecimal(pesoCargaKg),
      valor_etapa_producao: valorEtapaProducao,
      transportador: transportador,
      outro: outro,
      local_estoque: localEstoque,
      cor: cor,
      obs: safeObsHtml,
      empresa_id: user.empresa_id,
      prazo_entrega: prazoEntrega ? prazoEntrega : null,
      status_prazo_entrega: statusPrazoEntrega,
      status_carregamento: statusCarregamento,
      // Novos campos de data
      data_liberacao_financeiro: dataLiberacaoFinanceiro ? dataLiberacaoFinanceiro : null,
      data_assinatura_contrato: dataAssinaturaContrato ? dataAssinaturaContrato : null,
      data_liberacao_producao: dataLiberacaoProducao ? dataLiberacaoProducao : null,
    };

    try {
      // const response = await axios.post(`${apiUrl}/card/upsert`, esquadriaData);
      const response = await api.post(`/card/upsert`, esquadriaData);

      if (response.data) {
        // Atualiza o card no estado global

        setCards((prevCards) => prevCards.map(card => {
          if (card.card_id === idCard) {
            return { ...card, nome_obra: response.data[0].nome_obra };
          }
          return card;
        }));

        // Supondo que você tem uma função para fechar o modal
        setOpenCloseModuloEsquadriasModal(false);
        alert('Dados salvos com sucesso!');
      }

    } catch (error) {
      console.error('Erro ao salvar as informações do módulo de esquadrias:', error);
      alert('Erro ao salvar as informações. Por favor, tente novamente.');
    }
  };

  const [esquadriasData, setEsquadriasData] = useState(null);


  useEffect(() => {
    // Somente execute o código se `esquadriasData` tiver sido carregado
    if (!esquadriasData) return;

    // Função para converter o formato da data
    const formatDate = (dateString) => {
      if (!dateString) return ''; // Retorna uma string vazia se a data for nula ou indefinida
      const date = new Date(dateString);
      return date.toISOString().split('T')[0]; // Retorna a data no formato 'YYYY-MM-DD'
    };

    // Atualize os estados somente se houver dados válidos
    setNomeObra(esquadriasData.nome_obra || '');
    setContatoObra(esquadriasData.contato_obra || '');
    setPrevisaoMedicao(esquadriasData.previsao_medicao ? formatDate(esquadriasData.previsao_medicao) : '');
    setStatusMedicao(esquadriasData.status_medicao || 'Parado');
    setPrevisaoProducao(esquadriasData.previsao_producao ? formatDate(esquadriasData.previsao_producao) : '');
    setStatusProducao(esquadriasData.status_producao || 'Parado');
    setPrevisaoEntregaVidro(esquadriasData.previsao_entrega_vidro ? formatDate(esquadriasData.previsao_entrega_vidro) : '');
    setStatusEntregaVidro(esquadriasData.status_entrega_vidro || 'Parado');
    setPrevisaoVistoriaPre(esquadriasData.previsao_vistoria_pre ? formatDate(esquadriasData.previsao_vistoria_pre) : '');
    setStatusVistoriaPre(esquadriasData.status_vistoria_pre || 'Parado');
    setPrevisaoEntregaObra(esquadriasData.previsao_entrega_obra ? formatDate(esquadriasData.previsao_entrega_obra) : '');
    setStatusEntregaObra(esquadriasData.status_entrega_obra || 'Parado');
    setPrevisaoInstalacao(esquadriasData.previsao_instalacao ? formatDate(esquadriasData.previsao_instalacao) : '');
    setIstatusInstalacao(esquadriasData.status_instalacao || 'Parado');
    setPrevisaoVistoriaPos(esquadriasData.previsao_vistoria_pos ? formatDate(esquadriasData.previsao_vistoria_pos) : '');
    setStatusVistoriaPos(esquadriasData.status_vistoria_pos || 'Parado');
    setPrevisaoAssistencia(esquadriasData.previsao_assistencia ? formatDate(esquadriasData.previsao_assistencia) : '');
    setStatusAssistencia(esquadriasData.status_assistencia || 'Parado');
    setHorasProducao(esquadriasData.horas_producao || 0);
    setQuantidadeEsquadrias(esquadriasData.quantidade_esquadrias || 0);
    setQuantidadeQuadros(esquadriasData.quantidade_quadros || 0);
    setMetrosQuadrados(esquadriasData.metros_quadrados || 0);
    setVolumeConcretoM3(esquadriasData.volume_concreto_m3 ?? '');
    setVolumeCargaM3(esquadriasData.volume_carga_m3 ?? '');
    setPesoCargaKg(esquadriasData.peso_carga_kg ?? '');
    setValorEtapaProducao(esquadriasData.valor_etapa_producao || 0);
    setTransportador(esquadriasData.transportador || '');
    setOutro(esquadriasData.outro || '');
    setLocalEstoque(esquadriasData.local_estoque || '');
    setCor(esquadriasData.cor || '');
    setObsObra(sanitizeObsHtml(normalizeObsToHtml(esquadriasData.obs || '')));
    setPrazoEntrega(esquadriasData.prazo_entrega ? formatDate(esquadriasData.prazo_entrega) : '');
    setStatusPrazoEntrega(esquadriasData.status_prazo_entrega || 'Parado');
    setStatusCarregamento(esquadriasData.status_carregamento || 'Sem informação');

    // Novos campos de data
    setDataLiberacaoFinanceiro(esquadriasData.data_liberacao_financeiro ? formatDate(esquadriasData.data_liberacao_financeiro) : '');
    setDataAssinaturaContrato(esquadriasData.data_assinatura_contrato ? formatDate(esquadriasData.data_assinatura_contrato) : '');
    setDataLiberacaoProducao(esquadriasData.data_liberacao_producao ? formatDate(esquadriasData.data_liberacao_producao) : '');

    buscarCores();
  }, [esquadriasData]);



  // useEffect(() => {
  //   if (!esquadriasData)
  //     return;

  //   // Função para converter o formato da data
  //   const formatDate = (dateString) => {
  //     const date = new Date(dateString);
  //     return date.toISOString().split('T')[0]; // Retorna a data no formato 'YYYY-MM-DD'
  //   };


  //   setNomeObra(esquadriasData.nome_obra);
  //   setContatoObra(esquadriasData.contato_obra);
  //   setPrevisaoMedicao(formatDate(esquadriasData.previsao_medicao));
  //   setStatusMedicao(esquadriasData.status_medicao);
  //   setPrevisaoProducao(formatDate(esquadriasData.previsao_producao));
  //   setStatusProducao(esquadriasData.status_producao);
  //   setPrevisaoEntregaVidro(formatDate(esquadriasData.previsao_entrega_vidro));
  //   setStatusEntregaVidro(esquadriasData.status_entrega_vidro);
  //   setPrevisaoVistoriaPre(formatDate(esquadriasData.previsao_vistoria_pre));
  //   setStatusVistoriaPre(esquadriasData.status_vistoria_pre);
  //   setPrevisaoEntregaObra(formatDate(esquadriasData.previsao_entrega_obra));
  //   setStatusEntregaObra(esquadriasData.status_entrega_obra);
  //   setPrevisaoInstalacao(formatDate(esquadriasData.previsao_instalacao));
  //   setIstatusInstalacao(esquadriasData.status_instalacao);
  //   setPrevisaoVistoriaPos(formatDate(esquadriasData.previsao_vistoria_pos));
  //   setStatusVistoriaPos(esquadriasData.status_vistoria_pos);
  //   setPrevisaoAssistencia(formatDate(esquadriasData.previsao_assistencia));
  //   setStatusAssistencia(esquadriasData.status_assistencia);
  //   setHorasProducao(esquadriasData.horas_producao);
  //   setQuantidadeEsquadrias(esquadriasData.quantidade_esquadrias);
  //   setQuantidadeQuadros(esquadriasData.quantidade_quadros);
  //   setMetrosQuadrados(esquadriasData.metros_quadrados);
  //   setCor(esquadriasData.cor ? esquadriasData.cor : "");
  //   setObsObra(esquadriasData.obs ? esquadriasData.obs : "");
  //   setPrazoEntrega(formatDate(esquadriasData.prazo_entrega));
  //   setStatusPrazoEntrega(esquadriasData.status_prazo_entrega);

  //   buscarCores()
  // }, [esquadriasData]);


  useEffect(() => {
    const fetchEsquadriasData = async () => {
      try {
        // const response = await axios.get(`${apiUrl}/card/${idCard}/esquadrias`);
        const response = await api.get(`/card/${idCard}/esquadrias`);

        setEsquadriasData(response.data[0]);
      } catch (error) {
        console.error('Erro ao buscar as informações do módulo de esquadrias:', error);
      }
    };

    fetchEsquadriasData();
    buscarCores();
  }, [idCard]);



  const buscarCores = async () => {
    try {
      // const response = await axios.get(`${apiUrl}/users/getCores/${user.empresa_id}`);
      const response = await api.get(`/users/getCores/${user.empresa_id}`);


      setListCor(response.data);
    } catch (error) {
      console.error('Erro ao buscar cores:', error);
    }
  };

  function inputPreenchido(valor) {
    if (valor === null || valor === undefined || valor === '') {
      return 'solid 1px red'; // Retorna o valor para o caso não preenchido
    } else {
      return 'solid 1px blue'; // Retorna o valor para o caso preenchido
    }
  }


  // ------------------ FAKTORY -------------------------
  // ------------------ FAKTORY -------------------------
  // ------------------ FAKTORY -------------------------

  // const updatePrazoEntrega = async (numeroPedido, dtPrazoEntrega, event) => {
  //   event.preventDefault(); // Impede o comportamento padrão do botão
  //   try {
  //     console.log('dtPrazoEntrega', dtPrazoEntrega)
  //     const response = await axios.put(`${fileApiUrl}/faktory/pedidovenda/${numeroPedido}/prazoentrega`, {
  //       dtPrazoEntrega,
  //     });
  //     return response.data;
  //   } catch (error) {
  //     console.error('Erro ao atualizar prazo de entrega:', error);
  //     throw error;
  //   }
  // };

  // Função para determinar o tipo de documento baseado no produto
  const getTipoDocumentoByProduto = (produto) => {
    if (!produto) return 'PV';
    
    const produtoLower = produto.toLowerCase();
    if (produtoLower.trim().startsWith('pvsc')) return 'PVSC';
    if (produtoLower.includes('bwood+')) return 'PVB';
    if (produtoLower.includes('rodapé') || produtoLower.includes('rodape')) return 'PVR';
    if (produtoLower.includes('porta interna')) return 'PVPI';
    if (produtoLower.includes('esquadria')) return 'PV';
    if (produtoLower.includes('assist')) return 'PVAT';
    if (produtoLower.includes('retrabalho')) return 'RE';
    
    return 'PV'; // Valor padrão
  };

  useEffect(() => {
    let active = true;

    const fetchHistoricoPedidoVenda = async () => {
      const numeroPedido = Number.parseInt(currentCardData?.pedido_number, 10);

      if (!Number.isFinite(numeroPedido)) {
        setHistoricoPedidoVendaFaktory([]);
        setHistoricoFaktoryError('Informe o número do pedido Faktory no card para consultar o histórico.');
        return;
      }

      setHistoricoFaktoryLoading(true);
      setHistoricoFaktoryError('');

      try {
        const tipoDocumento = getTipoDocumentoByProduto(currentCardData?.produto);
        const response = await apiUploads.get(
          `/faktory/pedidovendahistorico/${numeroPedido}?tipoDocumento=${encodeURIComponent(tipoDocumento)}`
        );

        if (active) {
          setHistoricoPedidoVendaFaktory(Array.isArray(response.data) ? response.data : []);
        }
      } catch (error) {
        console.error('Erro ao buscar histórico do pedido de venda:', error);
        if (active) {
          setHistoricoPedidoVendaFaktory([]);
          setHistoricoFaktoryError('Não foi possível carregar o histórico do pedido de venda no Faktory.');
        }
      } finally {
        if (active) setHistoricoFaktoryLoading(false);
      }
    };

    fetchHistoricoPedidoVenda();

    return () => {
      active = false;
    };
  }, [currentCardData?.pedido_number, currentCardData?.produto]);

  const updatePrazoEntrega = async (numeroPedido, dtPrazoEntrega, event) => {
    event.preventDefault(); // Impede o comportamento padrão do botão
  
    // Exibir alerta de confirmação antes de executar a atualização
    const confirmacao = window.confirm("Tem certeza que deseja atualizar a previsão de entrega no sistema Faktory?");
    
    if (!confirmacao) {
      return; // Se o usuário cancelar, não faz nada
    }
  
    try {
      console.log('dtPrazoEntrega', dtPrazoEntrega);
      const tipoDocumento = getTipoDocumentoByProduto(currentCardData.produto);
      
      const response = await apiUploads.put(`/faktory/pedidovenda/${numeroPedido}/prazoentrega`, {
        dtPrazoEntrega,
        tipoDocumento
      });
  
      alert("Previsão de entrega atualizada com sucesso no sistema Faktory!"); // Exibir alerta de sucesso
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar prazo de entrega:', error);
      alert("Erro ao atualizar a previsão de entrega!"); // Exibir alerta de erro
    }
  };
  


  const [prazoentregaFaktory, setPrazoentregaFaktory] = useState('')

  useEffect(() => {
    const fetchPrazoEntrega = async () => {
      if (!currentCardData.pedido_number) return;

      try {
        const tipoDocumento = getTipoDocumentoByProduto(currentCardData.produto);
        const response = await apiUploads.get(`/faktory/pedidovenda/${currentCardData.pedido_number}/prazoentrega?tipoDocumento=${tipoDocumento}`);
        console.log('response.data.DT_PRAZOENTREGA', response.data.DT_PRAZOENTREGA)
        setPrazoentregaFaktory(response.data.DT_PRAZOENTREGA)
      } catch (error) {
        console.error('Erro ao buscar prazo de entrega:', error);
      }
    };
    fetchPrazoEntrega();
  }, [currentCardData.pedido_number, currentCardData.produto]);

  useEffect(() => {
    console.log(currentCardData.pedido_number)
    console.log(previsaoEntregaObra ? previsaoEntregaObra : 'Incorreto')

  }, [currentCardData, previsaoEntregaObra])



  function formatarData(dataString) {
    if (!dataString) return ''; // Retorna string vazia se a data for inválida
  
    const date = new Date(dataString);
  
    if (isNaN(date.getTime())) return ''; // Retorna string vazia se a conversão falhar
  
    const dia = String(date.getUTCDate()).padStart(2, '0');
    const mes = String(date.getUTCMonth() + 1).padStart(2, '0'); // Janeiro é 0, então adicionamos 1
    const ano = String(date.getUTCFullYear()).slice(-2); // Pega apenas os dois últimos dígitos do ano
  
    return `${dia}/${mes}/${ano}`;
  }
  
  const parseLocalYmd = (ymd) => {
    const parts = String(ymd).split('-');
    if (parts.length !== 3) return null;
    const year = parseInt(parts[0], 10);
    const monthIndex = parseInt(parts[1], 10) - 1;
    const day = parseInt(parts[2], 10);
    const d = new Date(year, monthIndex, day);
    return isNaN(d.getTime()) ? null : d;
  };
  
  const formatLocalYmd = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };
  
  const handleDiasAposMedicaoChange = (e) => {
    const dias = e.target.value;
    setDiasAposMedicao(dias);
    if (!previsaoMedicao) return;
    const baseDate = parseLocalYmd(previsaoMedicao);
    const diasNumero = parseInt(dias, 10);
    if (!baseDate || isNaN(diasNumero)) return;
    const result = new Date(baseDate);
    result.setDate(result.getDate() + diasNumero);
    setPrazoEntrega(formatLocalYmd(result));
  };

  const handlePrazoEntregaChange = (e) => {
    const value = e.target.value;
    setPrazoEntrega(value);
    if (!previsaoMedicao || !value) return;
    const baseDate = parseLocalYmd(previsaoMedicao);
    const targetDate = parseLocalYmd(value);
    if (!baseDate || !targetDate) return;
    const diffMs = targetDate.getTime() - baseDate.getTime();
    const days = Math.round(diffMs / (1000 * 60 * 60 * 24));
    setDiasAposMedicao(String(days));
  };

  // Função para o botão "Termo de medidas combinadas"
  const handleTermoMedidasCombinadas = async () => {
    try {
      const emailData = {
        to: 'pedidosesquadrias@bazze.com.br',
        subject: 'Nova Solicitação - Termo de Medidas Combinadas',
        text: `Uma nova solicitação do termo de medidas combinadas foi criada!

Cliente: ${currentCardData?.name || 'N/A'}
Documento: ${currentCardData?.document_number || 'N/A'}
Número do Pedido: ${currentCardData?.pedido_number || 'N/A'}
ID do Card: ${idCard}
Usuário: ${user?.username || 'N/A'} (${user?.email || 'N/A'})
Data: ${new Date().toLocaleDateString('pt-BR')}

Por favor, acesse o CRM para processar esta solicitação.`
      };

      await api.post(`/users/send-email/${user.empresa_id}`, emailData);
      
      // Adiciona histórico ao card
      addHistoricoCardContext(`Email enviado com sucesso: Termo de medidas combinadas para ${emailData.to}`, idCard, user.id);
      
      alert('Email enviado com sucesso para pedidosesquadrias@bazze.com.br!');
    } catch (error) {
      console.error('Erro ao enviar email:', error);
      alert('Erro ao enviar o email. Tente novamente.');
    }
  };

  // Função para o botão "Alteração de pedidos com medidas"
  const handleAlteracaoPedidosMedidas = async () => {
    try {
      const emailData = {
        to: 'orcamento@bazze.com.br',
        subject: 'Nova Solicitação - Alteração de Pedido com Medidas',
        text: `Uma nova solicitação de alteração de pedido foi criada!

Cliente: ${currentCardData?.name || 'N/A'}
Documento: ${currentCardData?.document_number || 'N/A'}
Número do Pedido: ${currentCardData?.pedido_number || 'N/A'}
ID do Card: ${idCard}
Usuário: ${user?.username || 'N/A'} (${user?.email || 'N/A'})
Data: ${new Date().toLocaleDateString('pt-BR')}

Por favor, acesse o CRM para processar esta solicitação.`
      };

      await api.post(`/users/send-email/${user.empresa_id}`, emailData);
      
      // Adiciona histórico ao card
      addHistoricoCardContext(`Email enviado com sucesso: Alteração de pedidos com medidas para ${emailData.to}`, idCard, user.id);
      
      alert('Email enviado com sucesso para orcamento@bazze.com.br!');
    } catch (error) {
      console.error('Erro ao enviar email:', error);
      alert('Erro ao enviar o email. Tente novamente.');
    }
  };

  useEffect(() => {
    const diasNumero = parseInt(diasAposMedicao, 10);
    if (!previsaoMedicao || isNaN(diasNumero)) return;
    const baseDate = parseLocalYmd(previsaoMedicao);
    if (!baseDate) return;
    const result = new Date(baseDate);
    result.setDate(result.getDate() + diasNumero);
    setPrazoEntrega(formatLocalYmd(result));
  }, [previsaoMedicao]);

  // Preenche automaticamente os dias ao abrir, se houver datas válidas
  useEffect(() => {
    if (!previsaoMedicao || !prazoEntrega) return;
    const baseDate = parseLocalYmd(previsaoMedicao);
    const targetDate = parseLocalYmd(prazoEntrega);
    if (!baseDate || !targetDate) return;
    const diffMs = targetDate.getTime() - baseDate.getTime();
    const days = Math.round(diffMs / (1000 * 60 * 60 * 24));
    setDiasAposMedicao(String(days));
  }, [previsaoMedicao, prazoEntrega]);
  


  const isSistemaConstrutivo = getTipoDocumentoByProduto(currentCardData?.produto) === 'PVSC';

  return (
    <div className='modulo-esquadrias-modal'>
      <div className='modulo-esquadrias-container'>
        <div className='header-update-card-container'>
          <label>Módulo de Produção</label>
        </div>
        <div className="modulo-esquadrias-form-container">
          <form className="modulo-esquadrias-form">

            <label htmlFor="nomeObra" className='modulo-esquadrias-label-input'>Nome da Obra:</label>
            <input id="nomeObra" className="modulo-esquadrias-input" type="text" name="nomeObra" value={nomeObra} onChange={(e) => setNomeObra(e.target.value)} style={{ border: inputPreenchido(nomeObra) }} />

            <label htmlFor="contatoObra" className='modulo-esquadrias-label-input'>Contato da Obra:</label>
            <input id="contatoObra" className="modulo-esquadrias-input" type="tel" name="contatoObra" value={contatoObra} onChange={(e) => setContatoObra(e.target.value)} style={{ border: inputPreenchido(contatoObra) }} />

            <div className='module-esquadrias-row-container'>
              <div className='module-esquadrias-column'>
                <label htmlFor="previsaoMedicao" className='modulo-esquadrias-label-input'>Previsão de Medição:</label>
                <input id="previsaoMedicao" className="modulo-esquadrias-input" type="date" name="previsaoMedicao" value={previsaoMedicao || ''} onChange={(e) => setPrevisaoMedicao(e.target.value)} style={{ border: inputPreenchido(previsaoMedicao) }} />
              </div>
              <div className='module-esquadrias-column'>
                <label htmlFor="statusMedicao" className='modulo-esquadrias-label-input'>Status:</label>
                <select id="statusMedicao" className="modulo-esquadrias-input" name="statusMedicao" value={statusMedicao} onChange={(e) => setStatusMedicao(e.target.value)} >
                  <option value="Parado">Parado</option>
                  <option value="EmAndamento">Em Andamento</option>
                  <option value="Parcial">Parcial</option>
                  <option value="Pronto">Pronto</option>
                </select>
              </div>
            </div>

            <div className='module-esquadrias-row-container'>
              <div className='module-esquadrias-column'>
                <label htmlFor="previsaoProducao" className='modulo-esquadrias-label-input'>Previsão de Produção:</label>
                <input id="previsaoProducao" className="modulo-esquadrias-input" type="date" name="previsaoProducao" value={previsaoProducao || ''} onChange={(e) => setPrevisaoProducao(e.target.value)} style={{ border: inputPreenchido(previsaoProducao) }} />
              </div>
              <div className='module-esquadrias-column'>
                <label htmlFor="statusProducao" className='modulo-esquadrias-label-input'>Status:</label>
                <select id="statusProducao" className="modulo-esquadrias-input" name="statusProducao" value={statusProducao} onChange={(e) => setStatusProducao(e.target.value)}>
                  <option value="Parado">Parado</option>
                  <option value="EmAndamento">Em Andamento</option>
                  <option value="Parcial">Parcial</option>
                  <option value="Pronto">Pronto</option>
                </select>
              </div>
            </div>

            <div className='module-esquadrias-row-container'>
              <div className='module-esquadrias-column'>
                <label htmlFor="previsaoEntregaVidro" className='modulo-esquadrias-label-input'>Previsão de Entrega de Vidros:</label>
                <input id="previsaoEntregaVidro" className="modulo-esquadrias-input" type="date" name="previsaoEntregaVidro" value={previsaoEntregaVidro || ''} onChange={(e) => setPrevisaoEntregaVidro(e.target.value)} style={{ border: inputPreenchido(previsaoEntregaVidro) }} />
              </div>




              <div className='module-esquadrias-column'>
                <label htmlFor="statusEntregaVidro" className='modulo-esquadrias-label-input'>Status:</label>
                <select id="statusEntregaVidro" className="modulo-esquadrias-input" name="statusEntregaVidro" value={statusEntregaVidro} onChange={(e) => setStatusEntregaVidro(e.target.value)}>
                  <option value="Parado">Parado</option>
                  <option value="EmAndamento">Em Andamento</option>
                  <option value="Parcial">Parcial</option>
                  <option value="Pronto">Pronto</option>
                </select>
              </div>
            </div>

            <div className='module-esquadrias-row-container'>
              <div className='module-esquadrias-column'>
                <label htmlFor="previsaoVistoriaPre" className='modulo-esquadrias-label-input'>Previsão de Vistoria Pré:</label>
                <input id="previsaoVistoriaPre" className="modulo-esquadrias-input" type="date" name="previsaoVistoriaPre" value={previsaoVistoriaPre || ''} onChange={(e) => setPrevisaoVistoriaPre(e.target.value)} style={{ border: inputPreenchido(previsaoVistoriaPre) }} />
              </div>
              <div className='module-esquadrias-column'>
                <label htmlFor="statusVistoriaPre" className='modulo-esquadrias-label-input'>Status:</label>
                <select id="statusVistoriaPre" className="modulo-esquadrias-input" name="statusVistoriaPre" value={statusVistoriaPre} onChange={(e) => setStatusVistoriaPre(e.target.value)}>
                  <option value="Parado">Parado</option>
                  <option value="EmAndamento">Em Andamento</option>
                  <option value="Parcial">Parcial</option>
                  <option value="Pronto">Pronto</option>
                </select>
              </div>
            </div>

            <div className='module-esquadrias-row-container'>

              <div className='module-esquadrias-column'>
                <label htmlFor="previsaoEntregaObra" className='modulo-esquadrias-label-input'>Previsão de Carregamento</label>
                <input id="previsaoEntregaObra" className="modulo-esquadrias-input" type="date" name="previsaoEntregaObra" value={previsaoEntregaObra || ''} onChange={(e) => setPrevisaoEntregaObra(e.target.value)} style={{ border: inputPreenchido(previsaoEntregaObra) }} />
              </div>

              <div className='module-esquadrias-column-faktory'>
                  <button  className="module-esquadrias-column-faktory-button" onClick={(e) => updatePrazoEntrega(currentCardData.pedido_number, previsaoEntregaObra, e)}>
                    Atualizar Faktory
                  </button>

                  <label style={{ color: 'red', fontSize: '13px' }}>{formatarData(prazoentregaFaktory)}</label>
              </div>

              <div className='module-esquadrias-column'>
                <label htmlFor="statusEntregaObra" className='modulo-esquadrias-label-input'>Status:</label>
                <select id="statusEntregaObra" className="modulo-esquadrias-input" name="statusEntregaObra" value={statusEntregaObra} onChange={(e) => setStatusEntregaObra(e.target.value)}>
                  <option value="Parado">Parado</option>
                  <option value="EmAndamento">Em Andamento</option>
                  <option value="Parcial">Parcial</option>
                  <option value="Pronto">Pronto</option>
                </select>
              </div>

            </div>

            <label htmlFor="statusCarregamento" className='modulo-esquadrias-label-input'>Status de Carregamento:</label>
            <select id="statusCarregamento" className="modulo-esquadrias-input" name="statusCarregamento" value={statusCarregamento} onChange={(e) => setStatusCarregamento(e.target.value)}>
              <option value="Sem informação">Sem informação</option>
              <option value="Carregamento programado">Carregamento programado</option>
              <option value="Aguardando Confirmação">Aguardando Confirmação</option>
              <option value="Carregamento Confirmado">Carregamento Confirmado</option>
              <option value="Aguardando data cliente">Aguardando data cliente</option>
              <option value="Data Confirmada pelo Cliente">Data Confirmada pelo Cliente</option>
            </select>



            <div className='module-esquadrias-row-container'>
              <div className='module-esquadrias-column'>
                <label htmlFor="previsaoInstalacao" className='modulo-esquadrias-label-input'>Previsão de Instalação:</label>
                <input id="previsaoInstalacao" className="modulo-esquadrias-input" type="date" name="previsaoInstalacao" value={previsaoInstalacao || ''} onChange={(e) => setPrevisaoInstalacao(e.target.value)} style={{ border: inputPreenchido(previsaoInstalacao) }} />
              </div>
              <div className='module-esquadrias-column'>
                <label htmlFor="statusInstalacao" className='modulo-esquadrias-label-input'>Status:</label>
                <select id="statusInstalacao" className="modulo-esquadrias-input" name="statusInstalacao" value={statusInstalacao} onChange={(e) => setIstatusInstalacao(e.target.value)}>
                  <option value="Parado">Parado</option>
                  <option value="EmAndamento">Em Andamento</option>
                  <option value="Parcial">Parcial</option>
                  <option value="Pronto">Pronto</option>
                </select>
              </div>
            </div>

            <div className='module-esquadrias-row-container'>
              <div className='module-esquadrias-column'>
                <label htmlFor="previsaoVistoriaPos" className='modulo-esquadrias-label-input'>Previsão de Vistoria Pós:</label>
                <input id="previsaoVistoriaPos" className="modulo-esquadrias-input" type="date" name="previsaoVistoriaPos" value={previsaoVistoriaPos || ''} onChange={(e) => setPrevisaoVistoriaPos(e.target.value)} style={{ border: inputPreenchido(previsaoVistoriaPos) }} />
              </div>
              <div className='module-esquadrias-column'>
                <label htmlFor="statusVistoriaPos" className='modulo-esquadrias-label-input'>Status:</label>
                <select id="statusVistoriaPos" className="modulo-esquadrias-input" name="statusVistoriaPos" value={statusVistoriaPos} onChange={(e) => setStatusVistoriaPos(e.target.value)}>
                  <option value="Parado">Parado</option>
                  <option value="EmAndamento">Em Andamento</option>
                  <option value="Parcial">Parcial</option>
                  <option value="Pronto">Pronto</option>
                </select>
              </div>
            </div>

            <div className='module-esquadrias-row-container'>
              <div className='module-esquadrias-column'>
                <label htmlFor="prazoEntrega" className='modulo-esquadrias-label-input'>Prazo maximo de entrega:</label>
                <input id="prazoEntrega" className="modulo-esquadrias-input" type="date" name="prazoEntrega" value={prazoEntrega} onChange={handlePrazoEntregaChange} style={{ border: inputPreenchido(prazoEntrega) }} />
              </div>
              <div className='module-esquadrias-column module-esquadrias-column-dias'>
                <label htmlFor="diasAposMedicao" className='modulo-esquadrias-label-input modulo-esquadrias-label-dias'>Dias após medição:</label>
                <input id="diasAposMedicao" className="modulo-esquadrias-input modulo-esquadrias-input-dias" type="number" min="0" placeholder="ex: 70" value={diasAposMedicao} onChange={handleDiasAposMedicaoChange} />
              </div>
              <div className='module-esquadrias-column'>
                <label htmlFor="statusProducao" className='modulo-esquadrias-label-input'>Status:</label>
                <select id="statusProducao" className="modulo-esquadrias-input" name="statusProducao" value={statusPrazoEntrega} onChange={(e) => setStatusPrazoEntrega(e.target.value)}>
                  <option value="Parado">Parado</option>
                  <option value="EmAndamento">Em Andamento</option>
                  <option value="Parcial">Parcial</option>
                  <option value="Pronto">Pronto</option>
                </select>
              </div>
            </div>

            <div className='module-esquadrias-row-container'>
              <div className='module-esquadrias-column'>
                <label htmlFor="previsaoAssistencia" className='modulo-esquadrias-label-input'>Previsão de Assistência:</label>
                <input id="previsaoAssistencia" className="modulo-esquadrias-input" type="date" name="previsaoAssistencia" value={previsaoAssistencia || ''} onChange={(e) => setPrevisaoAssistencia(e.target.value)} style={{ border: inputPreenchido(previsaoAssistencia) }} />
              </div>
              <div className='module-esquadrias-column'>
                <label htmlFor="statusAssistencia" className='modulo-esquadrias-label-input'>Status:</label>
                <select id="statusAssistencia" className="modulo-esquadrias-input" name="statusAssistencia" value={statusAssistencia} onChange={(e) => setStatusAssistencia(e.target.value)}>
                  <option value="Parado">Parado</option>
                  <option value="EmAndamento">Em Andamento</option>
                  <option value="Parcial">Parcial</option>
                  <option value="Pronto">Pronto</option>
                </select>
              </div>
            </div>

            <label htmlFor="dataLiberacaoFinanceiro" className='modulo-esquadrias-label-input'>Data de Liberação do Financeiro:</label>
            <input id="dataLiberacaoFinanceiro" className="modulo-esquadrias-input" type="date" name="dataLiberacaoFinanceiro" value={dataLiberacaoFinanceiro || ''} onChange={(e) => setDataLiberacaoFinanceiro(e.target.value)} style={{ border: inputPreenchido(dataLiberacaoFinanceiro) }} />

            <label htmlFor="dataAssinaturaContrato" className='modulo-esquadrias-label-input'>Data de Assinatura de Contrato:</label>
            <input id="dataAssinaturaContrato" className="modulo-esquadrias-input" type="date" name="dataAssinaturaContrato" value={dataAssinaturaContrato || ''} onChange={(e) => setDataAssinaturaContrato(e.target.value)} style={{ border: inputPreenchido(dataAssinaturaContrato) }} />

            <label htmlFor="dataLiberacaoProducao" className='modulo-esquadrias-label-input'>Data de Liberação para Produção:</label>
            <input id="dataLiberacaoProducao" className="modulo-esquadrias-input" type="date" name="dataLiberacaoProducao" value={dataLiberacaoProducao || ''} onChange={(e) => setDataLiberacaoProducao(e.target.value)} style={{ border: inputPreenchido(dataLiberacaoProducao) }} />

            <label htmlFor="address" className='modulo-esquadrias-label-input'>Total em Horas necessárias para Produção:</label>
            <input id="username" className="modulo-esquadrias-input" type="text" placeholder="" value={horasProducao} onChange={(e) => setHorasProducao(e.target.value)} style={{ border: inputPreenchido(horasProducao) }} />

            <label htmlFor="valorEtapaProducao" className='modulo-esquadrias-label-input'>Valor da etapa de produção:</label>
            <input id="valorEtapaProducao" className="modulo-esquadrias-input" type="text" placeholder="" value={valorEtapaProducao} onChange={(e) => setValorEtapaProducao(e.target.value)} style={{ border: inputPreenchido(valorEtapaProducao) }} />

            <label htmlFor="address" className='modulo-esquadrias-label-input'>Quantidade de Esquadrias:</label>
            <input id="username" className="modulo-esquadrias-input" type="text" placeholder="" value={quantidadeEsquadrias} onChange={(e) => setQuantidadeEsquadrias(e.target.value)} style={{ border: inputPreenchido(quantidadeEsquadrias) }} />

            <label htmlFor="address" className='modulo-esquadrias-label-input'>Quantidade de Quadros:</label>
            <input id="username" className="modulo-esquadrias-input" type="text" placeholder="" value={quantidadeQuadros} onChange={(e) => setQuantidadeQuadros(e.target.value)} style={{ border: inputPreenchido(quantidadeQuadros) }} />

            <label htmlFor="metrosQuadrados" className='modulo-esquadrias-label-input'>{isSistemaConstrutivo ? 'Área de parede (m²):' : 'Quantidade de Metros Quadrados:'}</label>
            <input id="metrosQuadrados" className="modulo-esquadrias-input" type="text" placeholder="" value={metrosQuadrados} onChange={(e) => setMetrosQuadrados(e.target.value)} style={{ border: inputPreenchido(metrosQuadrados) }} />

            {isSistemaConstrutivo && (
              <div className="modulo-esquadrias-sistema-construtivo-fields">
                <h3>Dados do Sistema Construtivo para documentos</h3>

                <label htmlFor="volumeConcretoM3" className='modulo-esquadrias-label-input'>Volume de concreto (m³):</label>
                <input
                  id="volumeConcretoM3"
                  className="modulo-esquadrias-input"
                  type="text"
                  inputMode="decimal"
                  placeholder="Ex.: 156,90"
                  value={volumeConcretoM3}
                  onChange={(e) => setVolumeConcretoM3(e.target.value)}
                />

                <label htmlFor="volumeCargaM3" className='modulo-esquadrias-label-input'>Volume da carga (m³):</label>
                <input
                  id="volumeCargaM3"
                  className="modulo-esquadrias-input"
                  type="text"
                  inputMode="decimal"
                  placeholder="Ex.: 202,19"
                  value={volumeCargaM3}
                  onChange={(e) => setVolumeCargaM3(e.target.value)}
                />

                <label htmlFor="pesoCargaKg" className='modulo-esquadrias-label-input'>Peso da carga (kg):</label>
                <input
                  id="pesoCargaKg"
                  className="modulo-esquadrias-input"
                  type="text"
                  inputMode="decimal"
                  placeholder="Ex.: 21573,64"
                  value={pesoCargaKg}
                  onChange={(e) => setPesoCargaKg(e.target.value)}
                />
              </div>
            )}

            <label htmlFor="transportador" className='modulo-esquadrias-label-input'>Transportador:</label>
            <input id="transportador" className="modulo-esquadrias-input" type="text" placeholder="" value={transportador} onChange={(e) => setTransportador(e.target.value)} />

            <label htmlFor="outro" className='modulo-esquadrias-label-input'>Outro:</label>
            <input id="outro" className="modulo-esquadrias-input" type="text" placeholder="" value={outro} onChange={(e) => setOutro(e.target.value)} />

            <label htmlFor="localEstoque" className='modulo-esquadrias-label-input'>Local do Estoque:</label>
            <input id="localEstoque" className="modulo-esquadrias-input" type="text" placeholder="" value={localEstoque} onChange={(e) => setLocalEstoque(e.target.value)} />

            <label htmlFor="city-state" className='update-card-label-input'>Cor:</label>

            <div className='select-cidade-estado-container'>
              <select id="cor" className="select-estado-cidade" value={cor} onChange={(e) => setCor(e.target.value)} >
                <option value="">Selecione a cor</option>
                {listCor.map(origem => (
                  <option key={origem.id} value={origem.name}>{origem.name}</option>
                ))}
              </select>
            </div>

            <section className="modulo-esquadrias-historico-faktory" aria-live="polite">
              <h3>Histórico do Pedido de Venda (Faktory)</h3>

              {historicoFaktoryLoading && (
                <p className="modulo-esquadrias-historico-mensagem">Carregando histórico...</p>
              )}

              {!historicoFaktoryLoading && historicoFaktoryError && (
                <p className="modulo-esquadrias-historico-erro">{historicoFaktoryError}</p>
              )}

              {!historicoFaktoryLoading && !historicoFaktoryError && historicoPedidoVendaFaktory.length === 0 && (
                <p className="modulo-esquadrias-historico-mensagem">Nenhum histórico encontrado.</p>
              )}

              {!historicoFaktoryLoading && historicoPedidoVendaFaktory.length > 0 && (
                <div className="modulo-esquadrias-historico-lista">
                  {historicoPedidoVendaFaktory.map((historico, index) => (
                    <div className="modulo-esquadrias-historico-item" key={`${index}-${historico.DS_HISTORICO || ''}`}>
                      <span aria-hidden="true">•</span>
                      <p>{historico.DS_HISTORICO || 'N/A'}</p>
                    </div>
                  ))}
                </div>
              )}
            </section>

            <label htmlFor="obs" className='modulo-esquadrias-label-input'>Observações:</label>

            <div className="modulo-esquadrias-quill">
              <ReactQuill
                theme="snow"
                value={obsObra}
                onChange={setObsObra}
                modules={quillModules}
                formats={quillFormats}
                placeholder="Digite as observações..."
              />
            </div>

            {/* Botões adicionais */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '20px', 
              margin: '20px 0',
              padding: '0 20px'
            }}>
              <button 
                type="button"
                className="update-module-esquadrias-button" 
                onClick={handleTermoMedidasCombinadas}
                style={{
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Termo de medidas combinadas
              </button>
              
              <button 
                type="button"
                className="update-module-esquadrias-button" 
                onClick={handleAlteracaoPedidosMedidas}
                style={{
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Alteração de pedidos com medidas
              </button>
            </div>

          </form>
        </div>

        {!getAccessLevel('editarModuloEsquadrias') && (
          <div style={{ 
            background: '#fff3cd', 
            border: '1px solid #ffeaa7', 
            borderRadius: '5px', 
            padding: '10px', 
            margin: '10px', 
            textAlign: 'center',
            color: '#856404'
          }}>
            ⚠️ Apenas usuários autorizados podem salvar alterações neste módulo
          </div>
        )}

        <div className='update-card-footer'>
          <button className="update-card-close-button" onClick={(e) => { setOpenCloseModuloEsquadriasModal(false) }}>Cancelar</button>
          <button 
            type="submit" 
            className="update-module-esquadrias-button" 
            onClick={(e) => handleSaveEsquadrias(e)}
            disabled={!getAccessLevel('editarModuloEsquadrias')}
            title={!getAccessLevel('editarModuloEsquadrias') ? "Apenas usuários autorizados podem salvar" : ""}
            style={{ 
              opacity: !getAccessLevel('editarModuloEsquadrias') ? 0.5 : 1,
              cursor: !getAccessLevel('editarModuloEsquadrias') ? 'not-allowed' : 'pointer'
            }}
          >
            Salvar
          </button>
        </div>
      </div>
    </div>

  );
}

export default ModuloEsquadrias; 
